export const TRIP_STATUS = {
  DRAFTS: "DRAFTS",
  WAITING_FOR_APPROVAL: "WAITING_FOR_APPROVAL",
  PUBLISHED: "PUBLISHED",
  ARCHIVED: "ARCHIVED",
};

export const TRIP_STATUS_OPTIONS = [
  { value: TRIP_STATUS.DRAFTS, label: "Brouillon" },
  { value: TRIP_STATUS.WAITING_FOR_APPROVAL, label: "En attente de validation" },
  { value: TRIP_STATUS.PUBLISHED, label: "Publié" },
  { value: TRIP_STATUS.ARCHIVED, label: "Archivé" },
];
